export default __webpack_public_path__ + "665fe2f7e0bfa5c6901d1387660e5ef6.png";